import _ from 'lodash';

export const cleanQuery = query => _.replace(_.kebabCase(_.deburr(query)), /-/g, '');

// Position de la saisie dans le nom, sinon dans le meilleur alias (null si aucune correspondance)
const findMatch = (partner, cleanedQuery) => {
    const nameIndex = cleanQuery(partner.name).indexOf(cleanedQuery);
    if (nameIndex !== -1) {
        return { byAlias: false, index: nameIndex };
    }

    const aliasIndexes = (partner.nameMatchings || [])
        .map(alias => cleanQuery(alias).indexOf(cleanedQuery))
        .filter(index => index !== -1);

    return aliasIndexes.length > 0 ? { byAlias: true, index: Math.min(...aliasIndexes) } : null;
};

// Nom réel avant alias, puis position de la saisie, puis ordre alphabétique
const compareMatches = (a, b) => {
    if (a.match.byAlias !== b.match.byAlias) {
        return a.match.byAlias ? 1 : -1;
    }

    if (a.match.index !== b.match.index) {
        return a.match.index - b.match.index;
    }

    return a.partner.name.localeCompare(b.partner.name, 'fr', { sensitivity: 'base' });
};

export const searchPartners = (partners, query) => {
    const cleanedQuery = cleanQuery(query);

    return partners
        .map(partner => ({ partner, match: findMatch(partner, cleanedQuery) }))
        .filter(({ match }) => match !== null)
        .sort(compareMatches)
        .map(({ partner }) => partner);
};



// WEBPACK FOOTER //
// ./src/services/search/utils.js